import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { InternalAtlasService } from '../atlas/atlas.service';
import { AppConfig, AppConfigService } from '../core/app-config.service';
import { CustomerVoiceRouterService } from '../core/cv-router.service';
import { AtlasData } from './atlas.service';

@Component({
  selector: 'app-atlas',
  templateUrl: './atlas.component.html',
  standalone: false,
})
export class AtlasComponent implements OnInit {
  partnerId$: Observable<string>;
  marketId$: Observable<string>;
  accountGroupId$: Observable<string>;
  customerVoiceId$: Observable<string>;
  isAtlasEnabled$: Observable<boolean>;

  atlasData$: Observable<AtlasData>;

  constructor(
    private appConfig: AppConfigService,
    private cvRouter: CustomerVoiceRouterService,
    public router: Router,
    private readonly atlasInternalService: InternalAtlasService,
  ) {}

  ngOnInit(): void {
    this.partnerId$ = this.appConfig.appConfig.pipe(map((config: AppConfig) => config.partnerId));
    this.marketId$ = this.appConfig.appConfig.pipe(map((config: AppConfig) => config.marketId));
    this.customerVoiceId$ = this.appConfig.appConfig.pipe(
      map((config: AppConfig) => config.vendorCenterAppId),
      startWith(''),
    );
    this.accountGroupId$ = this.cvRouter.accountGroupId;

    this.atlasData$ = combineLatest([this.partnerId$, this.marketId$, this.accountGroupId$]).pipe(
      map(([partnerID, marketID, accountGroupID]) => ({
        partnerID,
        marketID,
        accountGroupID,
      })),
    );
    this.isAtlasEnabled$ = this.atlasInternalService.isAtlasEnabled$;
  }
}
